import { GET_PLACEORDER_MULTILEG } from "../actionTypes";

const initialState = {
    arrMultiLeg: []
}



const placeOrderMultilegReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case GET_PLACEORDER_MULTILEG:
            return {
                ...state,
                arrMultiLeg: [
                { id: '1', oi: '20.65L', ltp: "1204.80L", strike: '1200', ltp2: "1205.80", ol2: "0.55L" },
                { id: '2', oi: '20.65L', ltp: "1203.80L", strike: '1205', ltp2: "1204.80", ol2: "0.55L" },
                { id: '3', oi: '20.65L', ltp: "1204.80L", strike: '1210', ltp2: "1203.80", ol2: "0.55L" },
                { id: '4', oi: '20.65L', ltp: "1203.80L", strike: '1215', ltp2: "1205.80", ol2: "0.55L" },
                { id: '5', oi: '20.65L', ltp: "1204.80L", strike: '1220', ltp2: "1204.80", ol2: "0.55L" },
                { id: '6', oi: '20.65L', ltp: "1204.80L", strike: '1225', ltp2: "1205.80", ol2: "0.55L" },
                ]
            }

        default:
            return state
    }

}

export default placeOrderMultilegReducer